import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.adminAuth);
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

export default AdminRoute;
